import _ from 'lodash'
import axios from 'axios'
import moment from 'moment'
import { ActionTree } from 'vuex';
import { RootState } from '@/store/types';
import {
  FinalReviewSheet,
  FinalReviewSheetsState,
  ReviewSheet,
  StudentWithFinalReview,
  FinalReviewSheetForRegister,
} from '@/store/lessons/finalReviewSheet/types';
import { periodType } from '@/store/common.types';

const actions: ActionTree<FinalReviewSheetsState, RootState> = {
  getFinalReviewSheetByLessonId: (
    { commit, dispatch, getters },
    { lessonId }: { lessonId: string },
  ) => axios.get(`/lessons/${lessonId}/frsGrade`)
    .then(async ({ data }) => {
      await Promise.all([
        ..._.compact([
          data.tutorId,
          data.substituteTutorId,
        ]).map((tutorId) => dispatch('getTutor', { tutorId })),
        dispatch('getLessonByScheduleId', { scheduleId: lessonId }),
      ])

      const finalReviewSheet: FinalReviewSheet = {
        lessonId,
        lesson: getters.findLessonByScheduleId(lessonId),
        students: _.map(data.students, (s): StudentWithFinalReview => {
          const forEditSource: any = (
            !s.temporaryGrade.isTemporary
            && !s.temporaryGrade.isWaitingApproved
            && s.publicGrades.length > 0
          )
            // 一時保存データがない、かつ承認待ちデータがない、かつ公開データがある場合は最新の公開データ
            ? _.first(s.publicGrades)
            // 一時保存データまたは初期値(temporaryGradeに設定される)
            : s.temporaryGrade

          return {
            student: getters.findStudentById(s.studentId),
            isLocked: s.isLocked,
            applicantId: s.applicantId,
            isWaitingApproved: s.temporaryGrade.isWaitingApproved,
            isApplication: s.isApplication,
            forEdit: {
              note: forEditSource.comment,
            },
            publics: _.map(s.publicGrades, (g): ReviewSheet => ({
              note: g.comment,
            })),
          }
        }),
      }

      commit('gotFinalReviewSheet', finalReviewSheet)
    }),
  /**
   * FRSの一時保存
   * @param {FinalReviewSheetForRegister} frs
   */
  temporarilySaveFinalReviewSheet: (
    context,
    frs: FinalReviewSheetForRegister,
  ) => axios.post(`/lessons/${frs.lessonId}/students/${frs.studentId}/frsGrade/temporary`, {
    comment: frs.note,
  }),

  /**
   * FRSを登録
   * @param {FinalReviewSheetForRegister} frs
   */
  registerFinalReviewSheet: (
    context,
    frs: FinalReviewSheetForRegister,
  ) => axios.post(`/lessons/${frs.lessonId}/students/${frs.studentId}/frsGrade`, {
    comment: frs.note,
  }),
};

export default actions;
